export const DOWNLOAD_PAYMENT_REPORT_REQUEST = "DOWNLOAD_PAYMENT_REPORT_REQUEST";
export const DOWNLOAD_PAYMENT_REPORT_SUCCESS = "DOWNLOAD_PAYMENT_REPORT_SUCCESS";
export const DOWNLOAD_PAYMENT_REPORT_FAILURE = "DOWNLOAD_PAYMENT_REPORT_FAILURE";
export const DOWNLOAD_PAYMENT_REPORT_RESET = "DOWNLOAD_PAYMENT_REPORT_RESET";
export const downloadPaymentReportRequest = (payload) => ({
    type: DOWNLOAD_PAYMENT_REPORT_REQUEST,
    payload,
});
export const downloadPaymentReportSuccess = (payload) => ({
    type: DOWNLOAD_PAYMENT_REPORT_SUCCESS,
    payload,
});
export const downloadPaymentReportFailure = (payload) => ({
    type: DOWNLOAD_PAYMENT_REPORT_FAILURE,
    payload,
});
export const downloadPaymentReportReset = () => ({
    type: DOWNLOAD_PAYMENT_REPORT_RESET,
});
